import React, { Component } from 'react';
import $ from 'jquery';

import './../scss/ShowHorizontalListing.scss';

import ShowCard from './ShowCard';
import LoadMoreVideoCard from './LoadMoreVideoCard';
import { arrayToChunks } from './../../util/lib';
import PropTypes from 'prop-types';
import ThemeWrapper, { EARTH } from './factory/ThemeWrapper';
import NavigationArrowE from './earth/ui/NavigationArrowE';
import NavigationArrow from './ui/NavigationArrow';

class ShowHorizontalListing extends Component {

	render() {
		
		const props = this.props,
			widgetData = props.data || {},
			data = widgetData.data || {},
			title = data.title || '',
			cards = data.cards || [],
			id = props.id,
			groupCards = this.groupCards,
			groupedCards = groupCards(cards, 4),
			groupedCardsSml = groupCards(cards, 1),
			theme = props.theme || '';
  
		return (
			<div className="v-widget show-horizontal-listing container">
				<div className="widget-title">
					<h2>{title}</h2>
				</div>
				{this.renderCarousel(id, 'carousel-lg', groupedCards, theme, cards.length <= 4)}
				{this.renderCarousel(id + '_2', 'carousel-sm', groupedCardsSml, theme, cards.length <= 1)}
			</div>
		);
	}

	renderCarousel(id, className, grouped_cards, theme = '', hideArrows = false) {
		const navArrowClassName = 'shl',
			ArrowComp = (theme === EARTH) ? NavigationArrowE : NavigationArrow;

		return <div id={id} className={"carousel slide w-100 " + className} data-ride="carousel">
			<div className="carousel-inner w-100" role="listbox">
				{grouped_cards.map((grp, index) => {
					const active = index === 0 ? 'active' : '';
					return (<div key={index} className={"carousel-item row no-gutters " + active}>
						{grp.map(item => { return item; })}
					</div>);
				})}

			</div>
			{!hideArrows && <ArrowComp className={navArrowClassName} direction={'prev'} id={id} lable={'previous'}/>}
			{!hideArrows && <ArrowComp className={navArrowClassName} direction={'next'} id={id} lable={'next'}/>}
		</div>;
	}

  groupCards(cards, no_cards) {
	const all_cards = [];
	cards.map((item, index) => {
		  if (item.type === 'ShowCard') {
			  all_cards.push(<ShowCard key={item.data.show_name + index} card={item} float='float-left' />);
		}
		if (item.type === 'LoadMoreVideoCard') {
			all_cards.push(<LoadMoreVideoCard key={item.data.title + index} card={item} float='float-left' />);
		}
		return false;
	});

	return arrayToChunks(all_cards, no_cards);
  }

  componentDidMount() {
	const carousel_id = '#' + this.props.id; 
	this.initCarousel(carousel_id);
	this.initCarousel(carousel_id + '_2');
  }

	initCarousel(carousel_id) {
		window.$(carousel_id).carousel({
			interval: false,
			wrap: true,
		});
		window.$(carousel_id + ' .carousel-control-prev').hide();
		// $(carousel_id + ' .carousel-control-next').hide();
		window.$(carousel_id).on('slid.bs.carousel', '', function () {
			var $this = $(this);
			var c_id = '#' + $this.attr('id');
			$this.children('.carousel-control-prev').show();
			$this.children('.carousel-control-next').show();
			if ($(c_id + ' .carousel-inner .carousel-item:first').hasClass('active')) {
				$this.children(c_id + ' .carousel-control-prev').hide();
			}
			if ($(c_id + ' .carousel-inner .carousel-item:last').hasClass('active')) {
				$this.children(c_id + ' .carousel-control-next').hide();
			}
		});
	}

  componentWillUnmount() {
	const carousel_id = '#' + this.props.id;
	window.$(carousel_id).carousel('dispose');
	window.$(carousel_id + '_2').carousel('dispose');
  }

}

ShowHorizontalListing.propTypes = {
	id: PropTypes.string,
	data: PropTypes.shape({
		data: PropTypes.shape({
			title: PropTypes.string,
			cards: PropTypes.array,
		})
	})
}
export default ThemeWrapper(ShowHorizontalListing);
